export default "__VITE_ASSET__RnPAc9P1__"